/*
 * @Description: main.js
 * @Author: victor
 * @Date: 2021-07-01 10:19:33
 * @LastEditTime: 2025-02-10 10:12:11
 * @LastEditors: Please set LastEditors
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import ElementUI from "element-ui";
// import 'element-ui/lib/theme-chalk/index.css';
import "./assets/theme/index.css";
import "./assets/css/fonts.css"
import "../static/css/allStyle.css";
import VideoPlayer from "vue-video-player";
import {i18n} from '@/assets/i18n/config/i18n'
// import Vconsole from "vconsole";
// new Vconsole()
Vue.config.productionTip = false;
Vue.use(VideoPlayer);
require("video.js/dist/video-js.css");
require("vue-video-player/src/custom-theme.css");
Vue.use(ElementUI);

import ScrollSelect from '@/utils/ScrollSelect';
Vue.use(ScrollSelect);


Vue.use(require('vue-wechat-title'));
Vue.directive('title', {//单个修改标题
  inserted: function (el, binding) {
  document.title = el.dataset.title
  }
 })
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  i18n,
  render: h => h(App),
  components: { App },
  template: "<App/>"
});
Vue.prototype.mywindow = window;



// WEBPACK FOOTER //
// ./src/main.js